module.exports = __webpack_public_path__ + "static/Averta-Bold-c5811285d935425e17d402aa74add8d9.eot";